import React from "react";
import {
  getDocumentAmount,
  getDocumentDate,
  getDocumentNumber,
  getDocumentStatus,
  getPartyName,
  initials,
  money,
} from "./documentHelpers";

const DocumentRecordCard = ({ row, config, active, onClick }) => {
  const status = getDocumentStatus(row, config);

  return (
    <button className={`document-record-card ${active ? "is-active" : ""}`} onClick={onClick}>
      <span className={`document-avatar ${status.tone}`}>{initials(getPartyName(row, config))}</span>
      <span className="document-record-main">
        <strong>{getPartyName(row, config)}</strong>
        <small>{getDocumentNumber(row, config)}</small>
        <b>{money(getDocumentAmount(row, config))}</b>
      </span>
      <span className="document-record-side">
        <time>{getDocumentDate(row, config)}</time>
        <span className={`document-pill ${status.tone}`}>{status.label}</span>
      </span>
    </button>
  );
};

export default DocumentRecordCard;
